import React, { useState } from "react";
import styles from "./ForgotPassword.module.css"; // Import the CSS module

const backend_api_base_url = `${process.env.REACT_APP_SL_BE_BASE_ENV_PART}/${process.env.REACT_APP_STAGE_ENV}`;

const ForgotPassword = () => {
  const [email, setEmail] = useState("");
  const [userType, setUserType] = useState("tenant_type"); // Default to tenant_type
  const [message, setMessage] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setMessage("");

    try {
      const response = await fetch(
        `https://auth2.${backend_api_base_url}/forgot_password?email=${email}&u_type=${userType}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ email }),
        }
      );

      if (response.ok) {
        setMessage("If the email exists, a reset link has been sent.");
      } else {
        const errorText = await response.text();
        setMessage(`Error: ${errorText}`);
      }
    } catch (error) {
      setMessage(`Error: ${error.message}`);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className={styles.forgotPasswordContainer}>
      <h1 className={styles.title}>Forgot Password</h1>
      <p className={styles.subtitle}>
        Enter your email address, and we will send you instructions to reset
        your password.
      </p>

      <form className={styles.form} onSubmit={handleSubmit}>
        <div className={styles.inputGroup}>
          <label htmlFor="email" className={styles.label}>
            Email Address
          </label>
          <input
            type="email"
            id="email"
            className={styles.input}
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
        </div>

        {/* Radio buttons for user type selection */}
        <div className={styles.radioGroup}>
          <label className={styles.radioLabel}>
            <input
              type="radio"
              value="tenant_type"
              checked={userType === "tenant_type"}
              onChange={(e) => setUserType(e.target.value)}
            />
            <span>Tenant User</span>
          </label>
          
          <label className={styles.radioLabel}>
            <input
              type="radio"
              value="support_type"
              checked={userType === "support_type"}
              onChange={(e) => setUserType(e.target.value)}
            />
            <span>Support User</span>
          </label>
        </div>

        <button
          type="submit"
          className={styles.submitButton}
          disabled={isSubmitting}
        >
          {isSubmitting ? "Submitting..." : "Submit"}
        </button>
      </form>

      {message && <p className={styles.message}>{message}</p>}
    </div>
  );
};

export default ForgotPassword;